import React, { useRef } from "react";
import { Footer, Navbar } from "../components";
/**
 * Layout component that wraps all pages with a common structure:
 * - Navbar at the top
 * - Footer at the bottom
 * - Scrollable content in between
 *
 * @component
 * @param {Object} props
 * @param {React.ReactNode} props.children - The page/content to be rendered inside the layout
 */

const MainLayout = ({ children }) => {
  const mainRef = useRef(null);

  return (
    <div
      ref={mainRef}
      className="overflow-x-hidden w-screen h-dvh min-h-dvh relative flex flex-col overflow-auto scrollbar-thin scrollbar-thumb-slate-700 scrollbar-track-slate-900">
      <Navbar mainRef={mainRef} />
      {children}
      <Footer />
    </div>
  );
};

export default MainLayout;
